<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15">
        <g fill="none" fill-rule="evenodd" stroke-linecap="round">
            <g stroke="#FFF" stroke-width="1.5">
                <g>
                    <g>
                        <path d="M.5 13L13.5 13M4 6L7 9" transform="translate(-1556 -193) translate(1541 186) translate(16 8)"/>
                        <path d="M7 6L10 9" transform="translate(-1556 -193) translate(1541 186) translate(16 8) matrix(-1 0 0 1 17 0)"/>
                        <path d="M7 0L7 9M.5 10L.5 13M13.5 10L13.5 13" transform="translate(-1556 -193) translate(1541 186) translate(16 8)"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'print-icon'
}
</script>